import { render, staticRenderFns } from "./update-base-case.vue?vue&type=template&id=3454978c&scoped=true"
import script from "./update-base-case.vue?vue&type=script&lang=ts"
export * from "./update-base-case.vue?vue&type=script&lang=ts"
import style0 from "./update-base-case.vue?vue&type=style&index=0&id=3454978c&prod&lang=less&scoped=true"
import style1 from "./update-base-case.vue?vue&type=style&index=1&id=3454978c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3454978c",
  null
  
)

export default component.exports